import type { z } from "zod";

import { UserEntity } from "~/entities/user/@x/auth";

const zIn = UserEntity.zSchema.omit({
  id: true,
  username: true,
  roles: true,
});
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
